$(document).ready(function () {
    //PROJECTS ACCORDION DROPDOWN SCRIPT START
    $('#projects-accordion').on('show.bs.collapse', function (e) {
        jQuery(e.target).siblings('.card-header').find('.link-text').text("Hide Details");
    })
    $('#projects-accordion').on('hide.bs.collapse', function (e) {
        jQuery(e.target).siblings('.card-header').find('.link-text').text("View Details");
    })
    //PROJECTS ACCORDION DROPDOWN SCRIPT END
});
